import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Upload } from '../../../../../Common';

import './index.scss';

const MutatePionPdfContent = ({ language, type, name, ...props }) => {
  const [field, , fieldHelpers] = useField(name);

  return (
    <div
      {...props}
      className={classNames(
        'mutate-pion-pdf-content',
        // eslint-disable-next-line react/destructuring-assignment
        props.className,
      )}
    >
      <input type="hidden" value={field.value} />
      <Upload
        {...props}
        name={name}
        lang={language}
        type={type}
        uploaded={field.value ? [field.value] : null}
        onSubmit={({ files }) => {
          fieldHelpers.setValue(files[0]);
          fieldHelpers.setTouched(true);
        }}
        onDelete={() => {
          fieldHelpers.setValue('');
          fieldHelpers.setTouched(false);
        }}
        onCopy={() => {}}
        className={classNames(
          'mutate-pion-pdf-content',
          // eslint-disable-next-line react/destructuring-assignment
          props.className,
        )}
      />
    </div>
  );
};

export default MutatePionPdfContent;
